  import React from "react";
import HomeBanner from "./HomeBanner"; 
import TrustedBanner from "./TrustedBanner.js";
import DigitalWorkforceSection from "./digitalworkforce.js";
import TalentPipeline from "./TalentPipeline.js";
// import Awards from "./Awards.js";
import Partners from "./Partners.js";
import EnterpriseResources from "./EnterpriseResources.js";
import AcademySolutions from "./AcademySolution.js";
import Reviews from "@pages/Program/Reviews/Reviews.js";
// import Faq from "../Faq/Faq.js";
import LeadForm from "./FormLead.js";
import SkilSection from "./SkilSection.js";
// import Awards from "./Awards";

const ForBusiness = () => {
  return (
    <div>
      <HomeBanner /> 
      <TrustedBanner />
      <SkilSection />
      {/* <DigitalWorkforceSection /> */}
      <AcademySolutions />
      {/* <Partners /> */}
      <TalentPipeline />
      <Reviews />
      {/* <Awards /> */}
      <EnterpriseResources />
      {/* <Faq /> */}
      <LeadForm />
    </div>
  );
};

export default ForBusiness;
